// extracted by mini-css-extract-plugin
var _1 = "Annotation-module__annotationLinkContainer--gUE38";
var _2 = "Annotation-module__compactAnnotationIconContainer--CaBFg";
var _3 = "Annotation-module__createContainer--K2HkV";
var _4 = "Annotation-module__fullIconContainer--tL7g1";
var _5 = "Annotation-module__icon--OBpTu";
var _6 = "Annotation-module__innerFullViewContainer--WdcnZ";
var _7 = "Annotation-module__preview--a4QQ1";
var _8 = "Annotation-module__previewContainer--KcyEP";
export { _1 as "annotationLinkContainer", _2 as "compactAnnotationIconContainer", _3 as "createContainer", _4 as "fullIconContainer", _5 as "icon", _6 as "innerFullViewContainer", _7 as "preview", _8 as "previewContainer" }
